import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

import { MatSort, Sort } from '@angular/material/sort';
import { DEFAULT_PAGE_SETTINGS, PaginationModel, PaginatorComponent } from '../paginator/app.paginator';

export interface SearchResult<T> {
  hasNextPage: boolean;
  payload: T[];
  errorMessage: string;
  limitExceeded?: boolean;
}

export interface SortModel {
  sortColumn: string;
  isDescSort: boolean;
}

@Component({
  template: '',
})
export abstract class BaseListTableComponent<TableItemsType> implements OnChanges {
  abstract displayedColumns: string[];
  abstract columnsNames: { [key: string]: string };

  @ViewChild('paginator') paginator!: PaginatorComponent;
  @ViewChild(MatSort) sort!: MatSort;

  @Input() tableData: SearchResult<TableItemsType> | any = {
    hasNextPage: false,
    payload: [],
    errorMessage: '',
  };
  @Input() hasNextPage = false;
  @Input() loading = false;
  @Input() selectedItemId: string | number | null = null;

  @Input() pagination: PaginationModel = {
    ...DEFAULT_PAGE_SETTINGS,
    pageSize: 5,
  };
  @Input() sorting: SortModel = {
    sortColumn: '',
    isDescSort: true,
  };

  @Output() paginationChanged: EventEmitter<PaginationModel> = new EventEmitter<PaginationModel>();
  @Output() sortingChanged: EventEmitter<SortModel> = new EventEmitter<SortModel>();

  /** Обработчик изменения входных параметров */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['hasNextPage']) {
      this.hasNextPage = changes['hasNextPage'].currentValue;
    }
  }

  /** Смена пагинации */
  onPaginationChanged(pagination: PaginationModel) {
    this.pagination = pagination;
    this.paginationChanged.emit(pagination);
  }

  /** Смена сортировки */
  onSortChanged(sortState: Sort) {
    this.sorting.sortColumn = sortState.active;
    this.sorting.isDescSort = sortState.direction == 'desc' ? true : false;
    if (!sortState.direction?.length) {
      this.sorting.sortColumn = '';
    }
    this.sortingChanged.emit(this.sorting);
  }

  /** Сброс номера страницы пагинации при фильтрации */
  resetPageNumber() {
    this.paginator.toFirstPage();
  }
}
